const src = import.meta.ROLLUP_FILE_URL_tgFyw$X211zXSctfMU9_LA;
export default {
  src,
  srcSet: src + " " + 302 + "w",
  width: 302,
  height: 314,
};